import React , {useState} from "react";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faPenToSquare,
  faSave,
  faCheck,
  faXmark,
  faFileLines ,  faArrowUp, faArrowDown
} from '@fortawesome/free-solid-svg-icons';
import api from "@/auth/api";
import { alertSuccess, alertError } from "@/components/Alert";

const DonationTable = ({
  headers,
  rows,
  editRowId,
  editedData,
  handleEdit,
  handleSave,
  handleCancel,
  handleChange,
  editableFields,
  handleLog,
  hideChangeLog,
  fetchData,
  agencyList,
  showAction,
//  fullData,
  // ✅ Selection props from parent
  selectedRows = [],
  setSelectedRows = () => {},
}) => {
 
const [sortConfig, setSortConfig] =useState({
  status: null,        // "asc" | "desc" | null
  is_complete: null,
});

const handleSort = (key) => {
  setSortConfig((prev) => {
    const newOrder =
      prev[key] === "asc" ? "desc" :
      prev[key] === "desc" ? null : "asc";

    return { ...prev, [key]: newOrder };
  });
};


const sortedRows = React.useMemo(() => {
  let sorted = [...rows];

  Object.keys(sortConfig).forEach((key) => {
    const order = sortConfig[key];
    if (!order) return;

    sorted.sort((a, b) => {
      if (order === "asc") {
        return (b[key] === true) - (a[key] === true); // true first
      } else {
        return (a[key] === true) - (b[key] === true); // false first
      }
    });
  });

  return sorted;
}, [rows, sortConfig]);

 const isAllSelected =
  rows.length > 0 && rows.every(r => selectedRows.includes(r.id));

  const isSomeSelected = rows.some(r => selectedRows.includes(r.id));

  // ✅ Toggle single row selection
  const handleSelectRow = (id) => {
    setSelectedRows(selectedRows.includes(id)
      ? selectedRows.filter((r) => r !== id)
      : [...selectedRows, id]
    );
  };

  // ✅ Select all rows
const handleSelectAll = () => {
  if (isAllSelected) {
    // unselect only current page rows
    setSelectedRows(prev =>
      prev.filter(id => !rows.some(r => r.id === id))
    );
  } else {
    // select only current page rows
    const pageIds = rows.map(r => r.id);

    setSelectedRows(prev => [
      ...prev,
      ...pageIds.filter(id => !prev.includes(id))
    ]);
  }
};

  // ✅ Upload image handler
  const handleUploadImage = async (row, file) => {
    try {
      const formData = new FormData();
      formData.append("DonationImage", file);
      formData.append("id", row.id);

      await api.patch(`/redeem/panel/donation`, formData, {
        headers: { "Content-Type": "multipart/form-data" }
      });

      alertSuccess("Image uploaded successfully");
      fetchData();
    } catch (error) {
      alertError(error?.response?.data?.errors || "Upload failed");
    }
  };

  return (
    <div className="tableContainer max-w-full w-[90vw] overflow-x-auto">
      <table className="table text-xs w-[88vw] border-collapse">

        {/* ================= HEADER ================= */}
        <thead className="stickyHeader bg-[var(--mainCol)] text-white">
          <tr>
            <th className="p-2 border text-center">
              <input
                className = "donationCheckbox"
                type="checkbox"
                 checked={isAllSelected}
                   ref={(el) => {
                  if (el) el.indeterminate = !isAllSelected && isSomeSelected;
                }}
                onChange={handleSelectAll}
              />
            </th>

            {/* {headers?.map((header, index) => (
              <th key={index} className="p-2 text-left border">
                {header.toUpperCase()}
              </th>
            ))} */}

            {headers?.map((header, index) => {
            const isSortable = ["status", "is_complete"].includes(header);

            return (
              <th key={index} className="p-2 text-left border">
                <div className="flex items-center gap-1">
                  {header.toUpperCase()}

                  {isSortable && (
                    <FontAwesomeIcon
                      icon={
                        sortConfig[header] === "asc"
                          ? faArrowUp
                          : sortConfig[header] === "desc"
                          ? faArrowDown
                          : faArrowUp
                      }
                      className="cursor-pointer text-[10px]"
                      onClick={() => handleSort(header)}
                    />
                  )}
                </div>
              </th>
            );
          })}

            

            {showAction && (
              <th className="p-2 border">ACTION</th>
            )}
          </tr>
        </thead>

        {/* ================= BODY ================= */}
        <tbody>
          {sortedRows?.map((row) => (
            <tr key={row.id} className="hover:bg-gray-50">

              {/* ✅ CHECKBOX */}
              <td className="p-2 border text-center">
                <input
                  type="checkbox"
                   className = "donationCheckbox"
                  checked={selectedRows.includes(row.id)}
                  onChange={() => handleSelectRow(row.id)}
                />
              </td>

              {/* ================= ROW DATA ================= */}
              {headers.map((header , index) => (
                <td key={header} className="p-2 border">

                  {/* ================= EDIT MODE ================= */}
                  {editRowId === row.id && editableFields?.includes(header) ? (

                    ['active','status','is_read','is_Finshed','is_Start','queryResolve','multipleOfPoints','is_complete'].includes(header) ? (
                      <div className="flex justify-center gap-2">
                        <FontAwesomeIcon
                          icon={faCheck}
                          color="green"
                          onClick={() => handleChange(null, header, true)}
                          className="cursor-pointer"
                        />
                        <FontAwesomeIcon
                          icon={faXmark}
                          color="red"
                          onClick={() => handleChange(null, header, false)}
                          className="cursor-pointer"
                        />
                      </div>
                    ) : header === 'agency' ? (
                      <select
                        value={editedData[header] || ''}
                        onChange={(e) => handleChange(e, header)}
                        className="w-full p-1 border"
                      >
                        <option value="">Select agency</option>
                        {agencyList?.map((m) => (
                          <option key={m.id} value={m.agencyName}>
                            {m.agencyName}
                          </option>
                        ))}
                      </select>
                    ) : ['detailFirstPage','detailEndPage'].includes(header) ? (
                      <textarea
                        value={editedData[header] || ''}
                        onChange={(e) => handleChange(e, header)}
                        className="w-full p-1 border text-[11px] h-20"
                      />
                    ) : (
                      <input
                        type="text"
                        value={editedData[header] || ''}
                        onChange={(e) => handleChange(e, header)}
                        className="w-full p-1 border"
                      />
                    )

                  ) : (

                    /* ================= VIEW MODE ================= */
                    row[header] === true ? (
                      <FontAwesomeIcon color="green" icon={faCheck} />
                    ) : row[header] === false ? (
                      <FontAwesomeIcon color="red" icon={faXmark} />
                    ) : header === "DonationImage" && row[header] ? (
                      <>
                        <img
                          src={row[header]}
                          className="max-h-16 mx-auto mb-2"
                        />
                        <label className="cursor-pointer text-xs">
                          Upload
                          <input
                            type="file"
                            hidden
                            onChange={(e) =>
                              handleUploadImage(row, e.target.files[0])
                            }
                          />
                        </label>
                      </>
                    ) : ['detailFirstPage','detailEndPage'].includes(header) ? (
                      <pre className="text-[10px]">{JSON.stringify(row[header], null, 2)}</pre>
                    ) : (
                      String(row[header])
                    )
                  )}
                </td>
              ))}

              {/* ================= ACTION ================= */}
              {showAction && (
                <td className="p-2 border">
                  {editRowId === row.id ? (
                    <>
                      <FontAwesomeIcon
                        icon={faSave}
                        onClick={handleSave}
                        className="cursor-pointer mr-2"
                      />
                      <FontAwesomeIcon
                        icon={faXmark}
                        onClick={handleCancel}
                        className="cursor-pointer"
                      />
                    </>
                  ) : (
                    <>
                      <FontAwesomeIcon
                        icon={faPenToSquare}
                        onClick={() => handleEdit(row.id)}
                        className="cursor-pointer"
                      />
                      {!hideChangeLog && (
                        <FontAwesomeIcon
                          icon={faFileLines}
                          onClick={() => handleLog(row.id)}
                          className="ml-2 cursor-pointer"
                        />
                      )}
                    </>
                  )}
                </td>
              )}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default DonationTable;